import { observer } from 'mobx-react-lite';
import { NavLink, useLocation } from 'react-router-dom';
import style from './SettingsLayout.module.scss';
import { accountMenuItems } from '../model/consts/accountMenuItems';
import { useFilteredAccountMenu } from '../model/hooks/useFilteredAccountMenu';

const SettingsMenu = observer(() => {
  const filteredItems = useFilteredAccountMenu(accountMenuItems);
  console.log(filteredItems);
  const location = useLocation();

  return (
    <div className={style['menu']}>
      <h2 className={style['menu__title']}>Настройки</h2>
      <div className={style['menu__page-list']}>
        {filteredItems.map((section) => {
          const isAnyChildActive = section.items.some(
            (item) => location.pathname === item.to
          );

          return (
            <div key={section.title} className={style['menu__section']}>
              <div className={style['menu__page-list_subtitle']}>
                <span
                  className={`${style['menu__page-list_subtitle_icon']} ${
                    isAnyChildActive
                      ? style['menu__page-list_subtitle_icon--active']
                      : ''
                  }`}
                >
                  {section.icon}
                </span>
                {section.title}
              </div>
              <div className={style['menu__page-list_items-wrapper']}>
                {section.items.map((item) => (
                  <div
                    key={item.to}
                    className={style['menu__page-list_item']}
                  >
                    <NavLink
                      to={item.to}
                      className={({ isActive }) =>
                        isActive
                          ? style['menu__page-list_item--active']
                          : ''
                      }
                    >
                      {item.label}
                    </NavLink>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export { SettingsMenu };
